import * as Yup from "yup";
import moment from "moment";
import phdFormModel from "./phdFormModel";
const {
  formField: {
    photo,
    //page1
    email,
    password,
    titleNameEng,
    firstNameEng,
    middleNameEng,
    lastNameEng,
    titleNameThai,
    firstNameThai,
    middleNameThai,
    lastNameThai,
    studentId,
    gender,
    dateOfBirth,
    maritalStatus,
    bloodType,
    idCard,
    nationality,

    //page2
    faculty,
    major,
    c2fScholarshipProgram,
    mobileThai,
    mobileCountry,
    mentor_id,
    mentorName,
    mentorEmail,
    startFellowship,
    contractEnd,
    researchArea,
    addressInThailand,
    addressInTheCountryOfResidence,
    //page3
    nameOfTheBachelorDegree,
    graduatedFromUniversityInstitute,
    country,
    dateOfBachelorDegreeGraduation,
    nameOfMasterDegree,
    graduatedMasterFromUniversityInstitute,
    country2,
    // Page 4
    workingExperienceList,
    publication,
    awards,
    cvOrResume
  }
} = phdFormModel;

const visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  /////page1////
  Yup.object().shape({
    [photo.name]: Yup.object()
      .shape({
        [photo.file]: Yup.mixed()
      })
      .nullable(),
    [email.name]: Yup.string().email().required(`${email.requiredErrorMsg}`),
    [password.name]: Yup.string()
      .min(8, "Password is too short - should be 8 chars minimum.")
      .matches(/[a-zA-Z]/, "Password can only contain Latin letters.")
      .required(`${password.requiredErrorMsg}`),
    [titleNameEng.name]: Yup.string().required(
      `${titleNameEng.requiredErrorMsg}`
    ),
    [firstNameEng.name]: Yup.string()
      .trim()
      .required(`${firstNameEng.requiredErrorMsg}`),
    [lastNameEng.name]: Yup.string()
      .trim()
      .required(`${lastNameEng.requiredErrorMsg}`),
    [titleNameThai.name]: Yup.string().required(
      `${titleNameThai.requiredErrorMsg}`
    ),
    [firstNameThai.name]: Yup.string()
      .trim()
      .required(`${firstNameThai.requiredErrorMsg}`),
    [lastNameThai.name]: Yup.string()
      .trim()
      .required(`${lastNameThai.requiredErrorMsg}`),
    [studentId.name]: Yup.string()
      .trim()
      .required(`${studentId.requiredErrorMsg}`),
    [gender.name]: Yup.string().required(`${gender.requiredErrorMsg}`),
    [dateOfBirth.name]: Yup.string().required(
      `${dateOfBirth.requiredErrorMsg}`
    ),
    [maritalStatus.name]: Yup.string().required(
      `${maritalStatus.requiredErrorMsg}`
    ),
    [bloodType.name]: Yup.string().required(`${bloodType.requiredErrorMsg}`),
    [nationality.name]: Yup.string()
      .trim()
      .required(`${nationality.requiredErrorMsg}`),
    [idCard.name]: Yup.string().trim().required(`${idCard.requiredErrorMsg}`)
  }),

  /////page2////
  Yup.object().shape({
    [faculty.name]: Yup.string().required(`${faculty.requiredErrorMsg}`),
    [major.name]: Yup.string().trim().required(`${major.requiredErrorMsg}`),
    [c2fScholarshipProgram.name]: Yup.string().required(
      `${c2fScholarshipProgram.requiredErrorMsg}`
    ),
    [mobileThai.name]: Yup.string()
      .trim()
      .required(`${mobileThai.requiredErrorMsg}`),
    [mobileCountry.name]: Yup.string()
      .trim()
      .required(`${mobileCountry.requiredErrorMsg}`),
    [mentor_id.name]: Yup.number(),
    [mentorName.name]: Yup.string().required(`${mentorName.requiredErrorMsg}`),
    [mentorEmail.name]: Yup.string().required(
      `${mentorEmail.requiredErrorMsg}`
    ),
    [startFellowship.name]: Yup.string().required(
      `${startFellowship.requiredErrorMsg}`
    ),
    [contractEnd.name]: Yup.string().required(
      `${contractEnd.requiredErrorMsg}`
    ),
    [researchArea.name]: Yup.string()
      .trim()
      .required(`${researchArea.requiredErrorMsg}`),
    [addressInThailand.name]: Yup.string()
      .trim()
      .required(`${addressInThailand.requiredErrorMsg}`),
    [addressInTheCountryOfResidence.name]: Yup.string()
      .trim()
      .required(`${addressInTheCountryOfResidence.requiredErrorMsg}`)
  }),

  /////page3////
  Yup.object().shape({
    [nameOfTheBachelorDegree.name]: Yup.string()
      .trim()
      .required(`${nameOfTheBachelorDegree.requiredErrorMsg}`),
    [graduatedFromUniversityInstitute.name]: Yup.string()
      .trim()
      .required(`${graduatedFromUniversityInstitute.requiredErrorMsg}`),
    [country.name]: Yup.string().trim().required(`${country.requiredErrorMsg}`),
    [dateOfBachelorDegreeGraduation.name]: Yup.string().required(
      `${dateOfBachelorDegreeGraduation.requiredErrorMsg}`
    )
  }),

  /////page4////
  Yup.object().shape({
    [workingExperienceList.name]: Yup.array().of(
      Yup.object().shape({
        // [workingExperienceList.subMenu[0].position.name]: Yup.string().required(
        //   `${workingExperienceList.subMenu[0].position.requiredErrorMsg}`
        // ),
        // [workingExperienceList.subMenu[0].companyOrganization.name]:
        //   Yup.string().required(
        //     `${workingExperienceList.subMenu[0].companyOrganization.requiredErrorMsg}`
        //   ),
        // [workingExperienceList.subMenu[0].country.name]: Yup.string().required(
        //   `${workingExperienceList.subMenu[0].country.requiredErrorMsg}`
        // ),
        [workingExperienceList.subMenu[0].started.name]: Yup.date()
          .nullable()
          // .required(
          //   `${workingExperienceList.subMenu[0].started.requiredErrorMsg}`
          // )
          .transform((v) => (v instanceof Date && !isNaN(v) ? v : null)),
        [workingExperienceList.subMenu[0].ended.name]: Yup.date().when(
          workingExperienceList.subMenu[0].stillInRole.name,
          {
            is: (stillRole) => stillRole === false,
            then: Yup.date()
              .nullable()
              // .required(
              //   `${workingExperienceList.subMenu[0].ended.requiredErrorMsg}`
              // )
              .transform((v) => (v instanceof Date && !isNaN(v) ? v : null))
          }
        ),
        [workingExperienceList.subMenu[0].stillInRole.name]: Yup.boolean()
      })
    ),
    // [publication.name]: Yup.string().required(
    //   `${publication.requiredErrorMsg}`
    // ),
    // [awards.name]: Yup.string().required(`${awards.requiredErrorMsg}`),
    [cvOrResume.name]: Yup.object()
      .shape({
        [cvOrResume.file]: Yup.mixed()
      })
      .nullable()
      .required(`${cvOrResume.requiredErrorMsg}`)
  })
];
